import { render, staticRenderFns } from "./QuickItemSideMenu.vue?vue&type=template&id=2ca68706"
import script from "./QuickItemSideMenu.vue?vue&type=script&lang=js"
export * from "./QuickItemSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ca68706')) {
      api.createRecord('2ca68706', component.options)
    } else {
      api.reload('2ca68706', component.options)
    }
    module.hot.accept("./QuickItemSideMenu.vue?vue&type=template&id=2ca68706", function () {
      api.rerender('2ca68706', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quickitem/QuickItemSideMenu.vue"
export default component.exports